import * as React from 'react';
export const IcDna = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.71 6.29a.999.999 0 00-1.42 0c-.096.098-.2.189-.31.27L17.44 4c.084-.112.174-.219.27-.32a1 1 0 10-1.42-1.41 6.432 6.432 0 00-1.83 5.16 6.39 6.39 0 00-7 7 6.48 6.48 0 00-5.16 1.84 1 1 0 00.325 1.639 1 1 0 001.095-.22c.087-.09.18-.173.28-.25L6.56 20c-.081.111-.172.215-.27.31a1 1 0 00.325 1.64 1 1 0 001.095-.22 6.48 6.48 0 001.84-5.16 6.39 6.39 0 007-7 6.47 6.47 0 005.16-1.84 1 1 0 000-1.44zM7.47 18.05L6 16.53a8.38 8.38 0 011.6-.08 8.37 8.37 0 01-.13 1.6zm2-3.51A8.31 8.31 0 019.53 13l1.52 1.52a7.647 7.647 0 01-1.6.02h.02zm3.84-1.25c-.096.098-.2.189-.31.27L10.44 11c.166-.22.361-.414.58-.58L13.56 13c-.082.104-.173.2-.27.29h.02zm1.18-2.24L13 9.53a7.65 7.65 0 011.6-.07 7.563 7.563 0 01-.13 1.59h.02zm2-3.51A7.574 7.574 0 0116.54 6l1.51 1.52a7.58 7.58 0 01-1.59.02h.03z'
      fill='currentColor'
    />
  </svg>
);
